module.exports = __webpack_public_path__ + "static/media/butterfly.fd166e33.jpg";